import type { WorkBook, WorkSheet } from 'xlsx';
import * as XLSX from 'xlsx';

/** AOA rows for one sheet (header: 1, empty cells as ''). */
export function sheetToAoa(sheet: WorkSheet): unknown[][] {
  return XLSX.utils.sheet_to_json<unknown[]>(sheet, {
    header: 1,
    defval: '',
    raw: false,
  });
}

/**
 * Run `analyzeSheet` on each workbook tab. Null means the sheet is not
 * this report; those tabs are skipped. Empty array → no matching header.
 */
export function collectSheetAnalyses<T>(
  workbook: WorkBook,
  analyzeSheet: (rows: unknown[][], sheetName: string) => T | null,
): T[] {
  const parts: T[] = [];
  for (const sheetName of workbook.SheetNames) {
    const sheet = workbook.Sheets[sheetName];
    if (!sheet) continue;
    const part = analyzeSheet(sheetToAoa(sheet), sheetName);
    if (part) parts.push(part);
  }
  return parts;
}
